module.exports = __webpack_public_path__ + "media/images/icons/tranquility-b4a957ea671dd0dc8fa5202822cd855b.png";